import { lazyLoadView } from '@router/helpers';
export default [
  {
    path: '/i/:id(\\d+)/diklat/peserta',
    name: 'diklat-peserta',
    component: () => lazyLoadView(import('@views/instansi/diklat/peserta/Index')),
    meta: {
      title: 'Daftar Peserta Guru Diklat',
    },
  },
  {
    path: '/i/:id(\\d+)/diklat/iht',
    name: 'diklat-iht',
    component: () => lazyLoadView(import('@views/instansi/diklat/iht/Index')),
    meta: {
      title: 'Laporan Pelaksanaan IHT',
    },
  },
  {
    path: '/i/:id(\\d+)/diklat/upt',
    name: 'diklat-upt',
    component: () => lazyLoadView(import('@views/instansi/diklat/upt/Index')),
    meta: {
      title: 'Laporan UPT Sekolah',
    },
  },
  {
    path: '/i/:id(\\d+)/diklat/dpp',
    name: 'diklat-dpp',
    component: () => lazyLoadView(import('@views/instansi/diklat/dpp/Index')),
    meta: {
      title: 'Diklat Platform Merdeka Mengajar',
    },
  },
  {
    path: '/i/:id(\\d+)/diklat/kp',
    name: 'diklat-pendampingan',
    component: () => lazyLoadView(import('@views/instansi/diklat/pendampingan/dkp/List')),
    meta: {
      title: 'Kelola Pendampingan oleh IN (Instruktur ad Interim)',
      api: 'kp',
    },
  },
  {
    path: '/i/:id(\\d+)/diklat/kp/:detail_id',
    name: 'detail-diklat-pendampingan',
    component: () => lazyLoadView(import('@views/instansi/diklat/pendampingan/dkp/Detail')),
    meta: {
      title: 'Detail Kelompok Pendampingan IN',
      api: 'kp',
    },
  },
  {
    path: '/i/:id(\\d+)/diklat/kp-pa',
    name: 'diklat-pendampingan-pa',
    component: () => lazyLoadView(import('@views/instansi/diklat/pendampingan/pa/List')),
    meta: {
      title: 'Laporan PMO & Pendampingan Individu',
      api: 'kp-pa',
    },
  },
  {
    path: '/i/:id(\\d+)/diklat/kp-pa/:detail_id',
    name: 'detail-diklat-pendampingan-pa',
    component: () => lazyLoadView(import('@views/instansi/diklat/pendampingan/pa/Detail')),
    meta: {
      title: 'Detail Laporan PMO & Pendampingan Individu',
      api: 'kp-pa',
    },
  },
  {
    path: '/i/:id(\\d+)/diklat/pendampingan',
    name: 'pendampingan',
    component: () => lazyLoadView(import('@views/instansi/diklat/pendampingan/dkp/List')),
    meta: {
      title: 'Daftar Kelompok Pendampingan KP',
      api: 'pendampingan',
    },
  },
  {
    path: '/i/:id(\\d+)/diklat/pendampingan/:detail_id',
    name: 'detail-pendampingan',
    component: () => lazyLoadView(import('@views/instansi/diklat/pendampingan/dkp/Detail')),
    meta: {
      title: 'Detail Kelompok Pendampingan KP',
      api: 'pendampingan',
    },
  },
  {
    path: '/i/:id(\\d+)/diklat/pelaporan',
    name: 'diklat-pelaporan',
    component: () => lazyLoadView(import('@views/instansi/diklat/pelaporan/pmo/List')),
    meta: {
      title: 'Daftar Laporan Ajuan Bantuan Pendampingan PA',
    },
  },
  {
    path: '/i/:id(\\d+)/diklat/lokakarya',
    name: 'diklat-lokakarya',
    component: () => lazyLoadView(import('@views/instansi/diklat/lokakarya/Main.vue')),
    meta: {
      title: 'Laporan Pendampingan Kelompok',
    },
  },
  {
    path: '/i/:id(\\d+)/diklat/pendampingan-lokakarya/:psp_kp_pa_id',
    name: 'detail-pendampingan-lokakarya',
    component: () => lazyLoadView(import('@views/instansi/diklat/lokakarya/DetailPendampingan')),
    meta: {
      title: 'Detail Laporan Pendampingan Kelompok',
    },
  },
  {
    path: '/i/:id(\\d+)/diklat/rekap-lokakarya',
    name: 'rekap-lokakarya',
    component: () => lazyLoadView(import('@views/instansi/diklat/lokakarya/Rekap.vue')),
    meta: {
      title: 'Rekapan Lembar Umpan Balik Kegiatan Pendampingan',
    },
  },
  {
    path: '/i/:id(\\d+)/diklat/rekap-feedback',
    name: 'rekap-feedback',
    component: () => lazyLoadView(import('@views/instansi/diklat/lokakarya/Feedback.vue')),
    meta: {
      title: 'Umpan Balik Kegiatan Pendampingan',
    },
  },
];
